import React from "react";
import Nav from "../../containers/Nav/Nav";
import Hero from "../../containers/Hero/Hero";
import Footer from "../../containers/Footer/Footer";

const Home = () => {
  return (
    <div>
      <Nav url={"/signup"} />
      <Hero />
      <Footer />
    </div>
  );
};

export default Home;
